<template>
  <rpm-card-list
      title="Serviços"
      :data="sourceServices"
      :loading="cardListLoading"
      :pagination="pagination"
      @change-page="getSourceServices"
      grid-class="lg:grid-cols-2 grid-cols-1 gap-6"
      disabled-item-key="enabled"
      :invert-disabled-item-key="true"
      disabled-card-classes="shadow-[inset_0px_0px_5px_1px_rgba(0,0,0,0.25)]"
  >
    <template #functions>
      <section class="w-full flex flex-row-reverse">
        <rpm-button
          class="w-6 h-6 rounded"
          font-size="text-sm"
          icon="fa-solid fa-plus"
          @click="openModal({
            source_service_category: {},
            source_service_type: {},
            source_service_priority: {}
          })"
        ></rpm-button>
      </section>
    </template>

    <template #search>
      <section class="grid md:grid-cols-2 grid-cols-1 gap-x-6 gap-y-3 w-full">
        <rpm-input
            v-model="searchForm.term"
            placeholder="ID, Nome..."
        ></rpm-input>

        <rpm-input
            type="select"
            placeholder="Categoria"
            v-model="searchForm.source_service_category_id"
            :options="[{id:'', name:''}].concat(sourceServiceCategories)"
            optionValue="id"
            optionLabel="name"
        ></rpm-input>
      </section>
    </template>

    <template #badges="{ item }">
      <badge
          :class="item.enabled ? 'bg-theme' : 'bg-gray-400'"
          :text-color="item.enabled ? 'text-white' : 'text-gray-600'"
      >
        ID: {{ item.id }}
      </badge>

      <badge
          :class="item.enabled ? 'bg-sky-700' : 'bg-gray-400'"
          :text-color="item.enabled ? 'text-white' : 'text-gray-600'"
          text-size="text-xxs"
      >
        {{ item.source_service_priority.name }}
      </badge>
    </template>

    <template #actions="{ item }">
      <rpm-button
          v-if="item.enabled"
          icon="fa-solid fa-eye-slash"
          color="transparent"
          tooltip-text="desativar"
          @click="item.enabled = false, toggleStatus(item.id)"
      ></rpm-button>

      <rpm-button
          v-else
          icon="fa-solid fa-eye"
          color="transparent"
          tooltip-text="ativar"
          @click="item.enabled = true, toggleStatus(item.id)"
      ></rpm-button>

      <rpm-button
          icon="fa-solid fa-pen-to-square"
          color="transparent"
          tooltip-text="editar"
          @click="openModal(item)"
      ></rpm-button>

      <rpm-button
          icon="fa-solid fa-diagram-project"
          color="transparent"
          tooltip-text="fluxograma"
          :to="{ name: 'SourceServicesShow', params: { id: item.id } }"
      ></rpm-button>
    </template>

    <template #info="{ item }">
      <span class="font-bold italic text-xxs mt-2 mb-1"> {{ item.name_format }} </span>
      <span class="font-bold text-lg"> {{ item.name }} </span>
      <span class="text-sm">
        <b>Categoria:</b> {{ item.source_service_category.name }}
      </span>
      <span class="text-sm"> <b>Tipo:</b> {{ item.source_service_type.name }} </span>
    </template>
  </rpm-card-list>

  <CreateSourceServiceModal 
    :open="modalOpen"
    @close="modalOpen = false"
    :form="sourceServiceForm"
    :loading="saveLoading"
    :errors="errors"
    @submit="save"
  />
  
</template>

<script>

import Badge from "#components/Badge.vue";
import RpmCardList from "#components/RpmCardList.vue";
import CreateSourceServiceModal from "../modals/create.vue";

import sourceServiceCategoryRepository from "#repositories/sourceServiceCategoryRepository";
import sourceServiceRepository from "#repositories/sourceServiceRepository";
import {request} from "#repositories/repository";

import {getErrors} from "#functions/validator";

export default {
  name: "SourceService",
  components: {
    CreateSourceServiceModal,
    RpmCardList,
    Badge
  },
  data() {
    return {
      errors: {
        source_service_category: {},
        source_service_type: {},
        source_service_priority: {}
      },
      searchTimer: null,
      sourceServiceForm: {
        source_service_category: {},
        source_service_type: {},
        source_service_priority: {}
      },
      modalOpen: false,
      cardListLoading: false,
      sourceServices: [],
      sourceServiceCategories: [],
      searchForm: {
        term: this.$route.query.term,
        source_service_category_id: this.$route.query.source_service_category_id
      },
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 12,
        last_page: 0,
        links: [],
      },
      saveLoading: false,
    };
  },
  async mounted() {
    await this.getSourceServices();
    this.sourceServiceCategories = (await sourceServiceCategoryRepository.getSourceServiceCategories()).data;
  },
  methods: {
    async getSourceServices(page = 0) {
      if (page && page !== 0) this.pagination.page = page;

      this.cardListLoading = true;

      await this.coreGetSourceServices();

      this.cardListLoading = false;
    },
    async coreGetSourceServices(){
      this.$router.push({
         path: this.$route.path, 
         query: {
          page: this.pagination.page,
          source_service_category_id: this.searchForm.source_service_category_id,
          term: this.searchForm.term
        } 
      });

      this.sourceServices = request.pagination(
        await sourceServiceRepository.getSourceServices({
          source_service_category_id: this.searchForm.source_service_category_id,
          term: this.searchForm.term,
          ...this.pagination,
        }),
        this.pagination
      );
    },
    searchSourceServices() {
      clearTimeout(this.searchTimer);

      this.searchTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.getSourceServices();
      }, 750);
    },
    openModal(item) {
      this.modalOpen = true;
      this.sourceServiceForm = item;
    },
    async save() {
      this.errors = {
        source_service_category: {},
        source_service_type: {},
        source_service_priority: {}
      };
      this.saveLoading = true;

      if (this.sourceServiceForm.id) {
        sourceServiceRepository.updateSourceService(this.sourceServiceForm.id, this.sourceServiceForm).then((response) => {
          this.$notify('Serviço modificado com sucesso', 'success');
          this.modalOpen = false;
        }).catch((response) => {
          this.$notify('Erro ao modificar o serviço', 'error');
          getErrors(this.errors, response.errors);
        }).finally(() => {
          this.saveLoading = false;
          this.coreGetSourceServices();
        });
      }else{
        sourceServiceRepository.storeSourceService(this.sourceServiceForm).then(() => {
          this.$notify('Serviço adicionado com sucesso', 'success');
          this.modalOpen = false;
        }).catch((response) => {
          this.$notify('Erro ao adicionar serviço', 'error');
          getErrors(this.errors, response.errors);
        }).finally(() => {
          this.saveLoading = false;
          this.coreGetSourceServices();
        });
      }
    },
    async toggleStatus(id) {
      await sourceServiceRepository.toggleStatus(id);
      await this.getSourceServices();
    }
  },
  watch: {
    'searchForm.source_service_category_id': 'searchSourceServices',
    'searchForm.term': 'searchSourceServices',
  }
};
</script>
